import { loginReducerTypes } from 'types/store/auth/login';

const loginState: loginReducerTypes.ILogin = {
    // Form
    email: '',
    password: '',

    // Reducer
    isLoading: false,

    // Response
    message: '',
    status: false,
    data: {
        name: '',
        token: '',
    },
};

export { loginState };
